import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editSpeed = ( {data, speedId} : {data: IPostEditSpeed | {}, speedId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/Speeds/UpdateSpeed/${speedId}`, data);
};

type QueryFnType = typeof editSpeed;

type UseEditSpeedOptions = {
  data: IPostEditSpeed | {};
  speedId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditSpeed = ({ config }: UseEditSpeedOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Ταχύτητας Γραμμής.`, 500);
            console.error('Couldnt edit Speed', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllSpeeds"])
            addNotification('Η Ταχύτητα Γραμμής Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editSpeed,
    })
}